import { ArtistEditorialPageDetailsFragment } from '@/gql/generated/graphql'
import { AllPurposeLink } from '@components/all-purpose-link'
import { BodyText, HeadlineText } from 'design-configuration/components'
import React from 'react'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'

type PressSectionProps = {
  artistInfo?: ArtistEditorialPageDetailsFragment | null
}

export const PressSection = ({ artistInfo }: PressSectionProps): React.ReactElement => {
  return (
    <div className="px-md gap-y-md flex flex-col">
      {artistInfo?.PressSection?.PressItem?.map((press) => (
        <div className="gap-y-xs flex flex-col" key={`${press?.publication}-${press?.title}`}>
          <AllPurposeLink
            href={press?.url || ''}
            onClick={() =>
              trackButtonClicked(TrackedButtonNames.artistPress, {
                artistPage: artistInfo,
                customProperties: {
                  'Routed to press item full url': press?.url,
                  'Routed to press item title': press?.title,
                  'Routed to press item publication': press?.publication
                }
              })
            }
          >
            <HeadlineText className="text-on-surface">{press?.title}</HeadlineText>
          </AllPurposeLink>
          <div className="gap-x-md flex flex-row">
            <BodyText className="text-on-surface-variant">{press?.publication}</BodyText>
            <BodyText className="text-on-surface-variant">{press?.date}</BodyText>
          </div>
        </div>
      ))}
    </div>
  )
}
